import React, { useContext, useState, useEffect, useMemo, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { AppContext } from '@utils/AppContext';
import Utils from '@utils/utils'
import { HOME_PAGE_TYPE, IMAGE_TYPE } from "@utils/CONST"
import styles from './index.module.scss'
import PayModal from '@view/compoents/payModal/payModal'
import Iconfont from '@utils/Iconfont';

import hp_cloth_normal from '@assets/images/home32x/hp_cloth_normal.svg';
import hp_cloth_active from '@assets/images/home32x/hp_cloth_active.svg';

import hp_model_normal from '@assets/images/home32x/hp_model_normal.svg';
import hp_model_active from '@assets/images/home32x/hp_model_active.svg';

import hp_shoes_normal from '@assets/images/home32x/hp_shoes_normal.svg';
import hp_shoes_active from '@assets/images/home32x/hp_shoes_active.svg';

import hp_video_normal from '@assets/images/home32x/hp_video_normal.svg';
import hp_video_active from '@assets/images/home32x/hp_video_active.svg';

import hp_goodsimage_normal from '@assets/images/home32x/hp_goodsimage_normal.svg';
import hp_goodsimage_active from '@assets/images/home32x/hp_goodsimage_active.svg';

import hp_goodscolorchange_normal from '@assets/images/home32x/hp_goodscolorchange_normal.svg';
import hp_goodscolorchange_active from '@assets/images/home32x/hp_goodscolorchange_active.svg';

import pose_image_normal from '@assets/images/home32x/pose_image_normal.svg';
import pose_image_active from '@assets/images/home32x/pose_image_active.svg';

import glass_image_normal from '@assets/images/home32x/glass_image_normal.svg';
import glass_image_active from '@assets/images/home32x/glass_image_active.svg';

import sim_image_normal from '@assets/images/home32x/sim_image_normal.svg';
import sim_image_active from '@assets/images/home32x/sim_image_active.svg';

import batchImahe_normal from '@assets/images/home32x/batchImahe_normal.svg';
import batchImahe_active from '@assets/images/home32x/batchImahe_active.svg';

const MENU_LIST = [
    {
        name: 'AI试衣',
        key: IMAGE_TYPE.CLOTHES,
        icon: hp_cloth_normal,
        icon_active: hp_cloth_active,
        pathname: "/home/homemain/clothes"
    }, {
        name: '同版型试衣',
        key: IMAGE_TYPE.SIM_TRYON,
        icon: sim_image_normal,
        icon_active: sim_image_active,
        pathname: "/home/homemain/simTryon"
    }, {
        name: '换模特/背景',
        key: IMAGE_TYPE.MODEL,
        icon: hp_model_normal,
        icon_active: hp_model_active,
        pathname: "/home/homemain/model"
    }, {
        name: '鞋子上脚',
        key: IMAGE_TYPE.SHOES,
        icon: hp_shoes_normal,
        icon_active: hp_shoes_active,
        pathname: "/home/homemain/shoesTryon"
    }, {
        name: '眼镜试戴',
        key: IMAGE_TYPE.GLASSES_TRYON,
        icon: glass_image_normal,
        icon_active: glass_image_active,
        pathname: "/home/homemain/glassesTryon"
    },
    {
        name: '姿势裂变',
        key: IMAGE_TYPE.POSE_TRYON,
        icon: pose_image_normal,
        icon_active: pose_image_active,
        pathname: "/home/homemain/poseTryon"
    },
    {
        name: '商品图',
        key: IMAGE_TYPE.COMMODITY,
        icon: hp_goodsimage_normal,
        icon_active: hp_goodsimage_active,
        pathname: "/home/homemain/commodity"
    }, {
        name: '商品换色',
        key: IMAGE_TYPE.COMMODITYRECOLOR,
        icon: hp_goodscolorchange_normal,
        icon_active: hp_goodscolorchange_active,
        pathname: "/home/homemain/commodityRecolor"
    }, {
        name: '模特视频',
        key: IMAGE_TYPE.MODEL_VIDEO,
        icon: hp_video_normal,
        icon_active: hp_video_active,
        pathname: "/home/homemain/model_video"
    }, 
    // {
    //     name: '企业版',
    //     key: 'batchImages',
    //     icon: batchImahe_normal,
    //     icon_active: batchImahe_active,
    //     pathname: "/home/product/batchImages",
    //     teamIcon: true
    // },
]

const Sidebar = () => {
    const navigate = useNavigate();
    const { globalHomePageType, config } = useContext(AppContext);
    const payChildRef = useRef(null);
    const location = useLocation()
 
    // 侧边栏列表
    const menuList = useMemo(() => {
        if (globalHomePageType == HOME_PAGE_TYPE.CLOTHING) {
            return [
                MENU_LIST[0], // AI试衣
                MENU_LIST[1], // AI模特
                MENU_LIST[2], // 鞋子上脚
                MENU_LIST[3], // 眼镜试戴
                MENU_LIST[4], // 同版型试衣
                MENU_LIST[5], // 姿势裂变
                // MENU_LIST[9], // 批量生图
            ]
        } else if (globalHomePageType == HOME_PAGE_TYPE.MERCHANDISE) {
            return [
                MENU_LIST[6], // 商品图
                MENU_LIST[7], // 商品换色
            ]
        } else if (globalHomePageType == HOME_PAGE_TYPE.MODEL_VIDEO) {
            return [
                MENU_LIST[8], // 模特视频
            ]
        } else return []
    }, [globalHomePageType])
    // 侧边栏点击
    const handleSpanClick = (menu) => {
        console.log('menu', menu.pathname)
        navigate(menu.pathname)
    }
    // 打开充值弹窗
    const openrechargeClick = () => {
        payChildRef.current.openrechargeClick()
    }

    // useEffect(() => {
    //     console.log('globalHomePageType', globalHomePageType)
    //     console.log('location', location)
    // }, [globalHomePageType, location])

    return (
        <div className={styles.Sidebar}>
            <div className={styles.Sidebar_top}>
                {
                    menuList.map(menu => (
                        <div
                            key={menu.key}
                            className={styles.Sidebar_item}
                            onClick={() => handleSpanClick(menu)}
                        >
                            <img
                                className={styles.sidebar_icon}
                                src={location.pathname == menu.pathname ? menu.icon_active : menu.icon}
                                alt=""
                            />
                            <p style={{ color: location.pathname == menu.pathname ? '#006EFF' : '#5B6673' }}>{menu.name}</p>
                            {menu.teamIcon && <span className={styles.teamIcon}></span>}
                        </div>
                    ))
                }
            </div>
            <div className={styles.Sidebar_bottom}>
                {
                    localStorage.getItem('channel') == 'taobao' ? null :
                        <div className={styles.RechargeTrigger} onClick={() => openrechargeClick()}>
                            <Iconfont type='icon-arcbeanrecharge' className={styles.Icon} />
                            <p>充值</p>
                        </div>
                }
                <div className={styles.ComplianceCopy}>
                    <span>结果由AI生成</span>
                    <span>持续调优中</span>
                    <span>请谨慎甄别</span>
                </div>
            </div>
            <PayModal ref={payChildRef}></PayModal>
        </div>
    );
};

export default Sidebar;